// extracted by mini-css-extract-plugin
export var tierContainer = "styles-module--tier-container--+kkhY";
export var tierHr = "styles-module--tier-hr--Grq3Z";
export var tierImg = "styles-module--tier-img--uWtUg";
export var tierMonthly = "styles-module--tier-monthly--dC5uI";
export var tierMoney = "styles-module--tier-money--jdzAO";
export var tierSlide = "styles-module--tier-slide--nAiTG";
export var tierTitle = "styles-module--tier-title--FGtrk";
export var pbCorrection = "styles-module--pb-correction--wuC6C";